import React, { useEffect, useState } from 'react';
import TextAreaField from '../../controls/Form/components/TextAreaField';
import Button from '../../controls/Button';
import BaseModal from '../BaseModal';

/**
 *
 * @param {{
 *  show?:boolean;
 *  declineModalInfo:string;
 *  title:string;
 *  onClose?(r:{result:boolean;message:string;}):void;
 *  isBusy?:boolean;
 * }} props
 * @returns {React.ReactElement|null}
 */
export const DeclineModal = props => {
  const { show, onClose, declineModalInfo, title, isBusy } = props;
  const [declineReqMessage, setDeclineReqMessage] = useState('');
  const [hasError, setError] = useState(false);

  const handleChange = (name, value) => {
    setDeclineReqMessage(value);
  };

  const modalBody = () => {
    return (
      <>
        {declineModalInfo ? (
          <p tabIndex={0} className="mb-2">
            {declineModalInfo}
          </p>
        ) : (
          ''
        )}

        <TextAreaField
          title="Decline message"
          name={'declineReqMessage'}
          value={declineReqMessage}
          limit={500}
          onChange={handleChange}
          alwaysDisplayErrorMessage
          onValidityChange={p => {
            console.log(p.errorMessage);
            setError(!!p.errorMessage);
          }}
        />

        <div className="lsn-decline-modal-undo-msg mt-2 pt-2" tabIndex={0}>
          <i className="far fa-exclamation-triangle color-dark-orange mr-2" />
          You will not be able to undo this action.
        </div>
      </>
    );
  };

  const modalControls = () => {
    return (
      <>
        <Button onClick={onCloseProxy(false)} outline primary>
          Go Back
        </Button>
        <Button onClick={onCloseProxy(true)} danger disabled={hasError}>
          Decline
        </Button>
      </>
    );
  };
  /**
   *
   * @param {boolean} result
   * @returns
   */
  const onCloseProxy =
    (result = false) =>
    () =>
      onClose?.({ result, message: declineReqMessage });

  useEffect(() => {
    return () => {
      setDeclineReqMessage('');
    };
  }, []);

  return (
    <BaseModal
      isBusy={isBusy}
      show={show}
      title={title}
      body={modalBody()}
      controls={modalControls()}
      modalBodyClass={'text-center'}
    />
  );
};

export default DeclineModal;
